import { computed, reactive } from "vue";
import type * as Misskey from "calckey-js";
import { legacyApi } from "@/api-client";

const instanceData = localStorage.getItem("instance");

export const instance: Misskey.entities.DetailedInstanceMetadata = reactive(
    instanceData
        ? JSON.parse(instanceData)
        : {
              // TODO: set default values
          },
);

export async function fetchInstance() {
    const meta = await legacyApi("meta", {
        detail: true,
    });

    for (const [k, v] of Object.entries(meta)) {
        instance[k] = v;
    }

    localStorage.setItem("instance", JSON.stringify(instance));
}

export const emojiCategories = computed<string[]>(() => {
    if (instance.emojis == null) return [];
    const categories = new Set<string>();
    for (const emoji of instance.emojis) {
        categories.add(emoji.category);
    }
    return Array.from(categories);
});

export const emojiTags = computed<string[]>(() => {
    if (instance.emojis == null) return [];
    const tags = new Set<string>();
    for (const emoji of instance.emojis) {
        for (const tag of emoji.aliases) {
            tags.add(tag);
        }
    }
    return Array.from(tags);
});
